import { defineMessages } from 'react-intl';

export default defineMessages({
    noPolicyChangeNotes: {
        id: 'gateway.views.endorsement-detail.No notes associated with this policy change',
        defaultMessage:
            'There are no notes associated with this policy change.',
    },
});
